export const emptyContent = {
    status: "",
    items_arr: [],
    items_obj: {},
    categories_arr: [],
    categories_obj: {},
};